<template>
    <router-link :to="`/projects/${project.id}`">
        <div style="display: flex; justify-content: space-between; align-items: center; height: 96px;">
            <div style="display: flex; align-items: center;">
                <div style="padding: 16px 16px 16px 0;">
                    <img height="64" width="64" :src="project.attributes.thumb_url" style="border-radius: 4px; object-fit: cover;">
                </div>
                <div>
                <div style="font-weight: 700; padding: 4px;">
                    {{project.attributes.name}}
                </div>
                <div style="font-weight: 300; font-size: 12px; padding: 4px; overflow-x: hidden;">
                    {{project.attributes.address}}
                </div>
            </div>
            </div>
            <div style="padding-right: 16px 0 16px 16px; color: lightgray;">
                <i class="fas fa-chevron-right"></i>
            </div>
        </div>
    </router-link>
</template>
<script>
export default {
    name: 'ProjectsListItem',
    props: ['project']
}
</script>